import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const  store = new Vuex.Store({
	state:{
		uname:'',
		uid:'',
		token:'',
		is_first_login:''
	},
	mutations: {
		changeUser (state,user) {
			state.uid = user.uid
			state.token = user.token
			state.uname = user.uname
			state.is_first_login=user.is_first_login
		}
	},
	getters:{
		getUName: (state)=>{
			return state.uname;
		}
	}
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js